import '../css/Verify.css'
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import "../css/Nav design.css";
import TopBar from './TopBar';
import { useEffect, useState } from 'react';
import OtpRequest from '../model/request/OtpRequest';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';
import { ToastContainer, toast } from "react-toastify";

function Numberotp() {
  var location = useLocation();
  var { userId, isFromRegistration, isFromForgot } = location.state || {};
  // var userObject = Object.setPrototypeOf(userRegister,UserRegister.prototype);   
  const navigation = useNavigate()
  // var userRegister= new UserRegister();

  var [code, setCode] = useState("");
  var [codeError, setCodeError] = useState();
  const rawVal = localStorage.getItem('loginVal');
  let loginVal = rawVal ? JSON.parse(rawVal) : null;
  let token = loginVal ? loginVal.token : null;



  function clicktologinscreen() {
    if (validation()) {
      verifyOtpAPICall();

    }
  }

  function validation() {
    var isFlage = true

    if (code == "") {
      setCodeError("please verify your code")
      isFlage = false
    }
    else {

      setCodeError("")

    }
    return isFlage;

  }

  function showToast(message) {
    toast.success(message, {
      position: "top-right",
      autoClose: 2000
    });
  }


  function showToastFailed(message) {
    toast.error(message, {
      position: "top-right",
      autoClose: 2000
    });
  }
//   useEffect(() => {
//     console.log("isFromRegistration", isFromRegistration);
//      if (isFromForgot) {
//       return;
//     }

//     if (!isFromRegistration && token) {
//       navigation('/Viewpage');
//     }
//     if (!isFromRegistration && (token == null || token == "")) {
//       navigation('/login');
//     }
   

//   }, [isFromRegistration, isFromForgot, token, navigation]);





  function verifyOtpAPICall() {
    var request = new OtpRequest();
    request.userId =loginVal.user_Id;
    request.otp = code;
    request.type = 0;
    console.log("Response:", JSON.stringify(request));
    axios.post(
      ApiConfig.getUrl("User/verify_otp"),
      JSON.stringify(request),
      {
        headers: {
          "Content-Type": "application/json",
        }
      }
    )
      .then(response => {

        const api = ApiResponse.fromJson(response.data);
        console.log("Response:", api);
        if (api.status == true && api.statusCode == 200) {
            navigation('/Viewpage', { state: { userId: userId }
                
            });
        
        //    else {
           
        //     setTimeout(() => {
        //       navigation('/login');
        //     }, 100);
        //   }


          

        } else {
          showToastFailed("Invalid OTP")
        }
      })
      .catch(error => {
        console.error("Error:", error);
      });
  }

  function resendOtpAPICall() {
    var request = new OtpRequest();
    request.userId = userId;
    console.log("Response:", JSON.stringify(request));
    axios.post(
      ApiConfig.getUrl("User/sendOTP"),
      JSON.stringify(request),
      {
        headers: {
          "Content-Type": "application/json",
        }
      }
    )
      .then(response => {

        const api = ApiResponse.fromJson(response.data);
        console.log("Response:", api);
        if (api.status == true && api.statusCode == 200) {
          showToast("OTP resend successfully!.")

        } else {
          showToastFailed("Resend OTP Failed")
        }
      })
      .catch(error => {
        console.error("Error:", error);
      });
  }
  const disableRightClick = (e) => {
    e.preventDefault();
  };
  return (
    <>
      <div onContextMenu={disableRightClick}>
        <TopBar />
        <ToastContainer />

        <div className='fullview' style={{ backgroundColor: 'white' }}>

          <div className="card  h-100 w-100s" >
            <p className="h5 text-center mt-2 pt-2">OTP Verification</p>
            <p className="h6 text-center ">Enter the 4-digit code sent to your Email</p>

            <div className="otp-input mt-2 ms-1 ">
              <input type="number" max="1" required value={code} onChange={(e) => setCode(e.target.value)} />


            </div>
            <div style={{ display: "flex", justifyContent: "center", position: "relative" }}>

              <button onClick={clicktologinscreen} type="button" className='btn' style={{ background: "var(--primary-color)" }} >Verify</button>
            </div>
            <span className='input-error'>{codeError}</span>
            <p className="h6 text-center ">Didn't receive code yet? <span onClick={resendOtpAPICall}>Resend code</span> </p>

          </div>
        </div>
      </div>
      <footer className='bg-dark text-white text-center'>
        <label style={{ fontSize: "12px" }}>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
      </footer>
    </>

  );
}

export default Numberotp;